export default __webpack_public_path__ + "static/media/Montserrat-Light.02afb26f.ttf";